import { secondary } from '../theme';
import { Guest, ICheckInsProps, ITagList, themeTypes } from "../interfaces";
import { correctName } from "../services/generalServices";
import AirbnbIcon from '../assets/channels/airbnb-gray-icon.svg';
import bookingcomIcon from '../assets/channels/bookingcom-gray-icon.svg';
import decolarIcon from '../assets/channels/decolar-gray-icon.svg';
import expediaIcon from '../assets/channels/expedia-gray-icon.svg';
import apiIcon from '../assets/channels/api-gray-icon.svg';
import casaTemporadaIcon from '../assets/channels/casa-temporada-icon.svg';
import googlevrIcon from '../assets/channels/googlevr-gray-icon.svg';
import housiIcon from '../assets/channels/housi-gray-icon.svg';
import staysIcon from '../assets/channels/stays-gray-icon.svg';
import temporadalivreIcon from '../assets/channels/temporadalivre-gray-icon.svg';
import vrboIcon from '../assets/channels/vrbo-gray-icon.svg';
import websiteIcon from '../assets/channels/website-gray-icon.svg';
import yucaIcon from '../assets/channels/yuca-icon.svg';
import homeVillasIcon from '../assets/channels/homes-villas-icon.svg';
import { Flex } from '@mantine/core';
import { CgHome, CgHomeScreen } from 'react-icons/cg';
import { FaUserTag, FaWhatsapp } from 'react-icons/fa';
import { MdOutlineEmail } from 'react-icons/md';

export interface iGetOrigin {
  theme: themeTypes;
  origin: string;
}
type OriginKey =
  | 'EXTERNAL API'
  | 'API AIRBNB'
  | 'API BOOKING.COM'
  | 'API DECOLAR'
  | 'API EXPEDIA'
  | 'CASA TEMPORADA'
  | 'API GOOGLEVR'
  | 'TEMPORADA LIVRE'
  | 'VRBO'
  | 'YUCA'
  | 'HOUSI'
  | 'HOMES & VILLAS'
  | 'DESCONHECIDO'
  | 'WEBSITE';

type OriginValue = {
  color: string;
  icon?: string;
};

const origin_mapper: Record<OriginKey, OriginValue> = {
  'EXTERNAL API': {
    color: '#CCCCCC',
    icon: apiIcon
  },
  'API AIRBNB': {
    color: '#ED6665',
    icon: AirbnbIcon
  },
  'API BOOKING.COM': {
    color: '#183B79',
    icon: bookingcomIcon
  },
  'API DECOLAR': {
    color: '#5924E9',
    icon: decolarIcon
  },
  'API EXPEDIA': {
    color: '#F3C244',
    icon: expediaIcon
  },
  'CASA TEMPORADA': {
    color: '#C23041',
    icon: casaTemporadaIcon
  },
  'API GOOGLEVR': {
    color: '#34A853',
    icon: googlevrIcon
  },
  'TEMPORADA LIVRE': {
    color: '#439AC5',
    icon: temporadalivreIcon
  },
  'VRBO': {
    color: '#122248',
    icon: vrboIcon
  },
  'YUCA': {
    color: '#333333',
    icon: yucaIcon
  },
  'HOUSI': {
    color: '#DD4B70',
    icon: housiIcon
  },
  'HOMES & VILLAS': {
    color: '#EA996E',
    icon: homeVillasIcon
  },
  'DESCONHECIDO': {
    color: '#3EBCE2',
    icon: staysIcon
  },
  'WEBSITE': {
    color: '#333333',
    icon: websiteIcon
  },
}

const get_first_name = (broker: any) => {
  return broker.registration_data?.name || "";
};

export const getGuests: React.FC<{
  guests: ICheckInsProps["guests"];
  theme: "dark" | "light";
  accommodation_stays_id?: string
}> = ({ guests, theme, accommodation_stays_id }) => {
  return (
    <>
      <div>
        {guests?.filter(({ name }) => !!name)?.map((guest: any) => {
          return (
            <div key={guest?.id}>
              <div
                style={{
                  display: 'inline-block', // Ajusta a largura ao conteúdo
                  padding: 4,
                  paddingLeft: 7,
                  paddingRight: 7,
                  borderRadius: 3,
                  background: secondary[theme],
                  color: "#FFF",
                  fontWeight: 600,
                  fontSize: 12,
                }}
              >
                {guest.name}
              </div>
              <div style={{ fontSize: 12, marginTop: 4 }}>
                {accommodation_stays_id && accommodation_stays_id}
              </div>
            </div>
          );
        })}
      </div>

      {guests?.length === 0 && (
        <span style={{ fontStyle: "italic", opacity: 0.7, fontSize: 14, marginTop: 12 }}>
          Nenhum(a)
        </span>
      )}
    </>
  );
};

export const getGuestWithAdicionalGuestsBadge: React.FC<{
  guests: Guest[];
  theme: "dark" | "light";
  accommodation_stays_id?: string
}> = ({ guests, theme, accommodation_stays_id }) => {
  const guestPrimary = guests.filter(({ primary }) => !!primary)?.[0] ?? {};

  const qtdOthersGuest = guests.filter(({ primary }) => !primary)?.length || 0;

  return (
    <>
      <div>
        <div>
          <Flex align='center' style={{ fontWeight: 600 }}>
            {guestPrimary.name}

            {!guestPrimary.name && (
              <span style={{ fontStyle: "italic", opacity: 0.7, fontSize: 14, minHeight: '26px' }}>
                Não informado
              </span>
            )}

            {qtdOthersGuest > 0 && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  textAlign: 'center',
                  justifyContent: 'center',
                  marginLeft: 4,
                  padding: 4,
                  paddingLeft: 5,
                  paddingRight: 7,
                  borderRadius: 3,
                  background: secondary[theme],
                  color: "#FFF",
                  fontSize: 12,
                }}
              >
                +{qtdOthersGuest}
              </div>
            )}
          </Flex>
          <div style={{ fontSize: 12, marginTop: 4 }}>
            {accommodation_stays_id && accommodation_stays_id}
          </div>
        </div>
      </div>
    </>
  );
};

export const getSmartlock: React.FC<ITagList> = ({
  smartlock_alias,
  smartlock_type,
  theme,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex" }} key={smartlock_alias}>
        <div
          style={{
            padding: 5,
            whiteSpace: "nowrap",
            display: "flex",
            paddingLeft: 7,
            paddingRight: 7,
            borderRadius: 3,
            background: secondary[theme],
            color: "#FFF",
            fontWeight: 600,
            fontSize: 12,
          }}
        >
          <CgHomeScreen size={16} style={{ marginTop: 0.72, marginRight: 3 }} /> {smartlock_type} - {smartlock_alias}
        </div>
      </div>
    </div>
  );
};

export const getGeneralBadge: React.FC<ITagList> = ({
  name,
  icon,
  theme,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex" }} key={name}>
        <div
          style={{
            padding: 5,
            whiteSpace: "nowrap",
            display: "flex",
            paddingLeft: 7,
            paddingRight: 7,
            borderRadius: 3,
            background: secondary[theme],
            color: "#FFF",
            fontWeight: 600,
            fontSize: 12,
          }}
        >
          {icon ? icon : null} {name}
        </div>
      </div>
    </div>
  );
};

export const getModelMsgType: React.FC<ITagList> = ({
  type,
  theme,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex", marginLeft: -55 }} key={type}>
        <div
          style={{
            padding: 5,
            whiteSpace: "nowrap",
            display: "flex",
            paddingLeft: 7,
            paddingRight: 7,
            borderRadius: 3,
            background: '#2d1b67',
            color: "#FFF",
            fontWeight: 600,
            fontSize: 12,
          }}
        >
          {type === 'WhatsApp' ? <FaWhatsapp size={16} style={{ marginTop: 0.72, marginRight: 3 }} /> : <MdOutlineEmail size={16} style={{ marginTop: 0.72, marginRight: 3 }} />}
          {type}
        </div>
      </div>
    </div>
  );
};

export const getUserTypeBadge: React.FC<ITagList> = ({
  type,
  theme,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex" }} key={type}>
        <div
          style={{
            padding: 5,
            whiteSpace: "nowrap",
            display: "flex",
            paddingLeft: 7,
            paddingRight: 7,
            borderRadius: 3,
            background: '#2d1b67',
            color: "#FFF",
            fontWeight: 600,
            fontSize: 12,
            flex: 1
          }}
        >
          <FaUserTag size={16} style={{ marginTop: 0.72, marginRight: 3 }} />
          {type}
        </div>
      </div>
    </div>
  );
};

export const getOrigin: React.FC<iGetOrigin> = ({
  origin,
  theme,
}) => {
  const originData = origin_mapper[origin.toUpperCase() as OriginKey] ?? {
    title: 'STAYS',
    color: '#3EBCE2',
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex" }}>
        <div
          style={{
            padding: 7,
            borderRadius: '100%',
            background: originData.color,
            color: "#FFF",
          }}
        >
          <img src={originData.icon} width={23} height={23} />
        </div>
      </div>
    </div>
  );
};

export const getAreasGroups: React.FC<ITagList> = ({ areas_groups, theme, smartlock_type }) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
      }}
    >
      {areas_groups?.map(({ id, name }: any) => {
        return (
          <div style={{ display: "flex" }} key={id}>
            <div
              style={{
                padding: 5,
                whiteSpace: "nowrap",
                display: "flex",
                paddingLeft: 7,
                paddingRight: 7,
                borderRadius: 3,
                background: secondary[theme],
                color: "#FFF",
                fontWeight: 600,
                fontSize: 12,
              }}
            >
              <CgHome size={16} style={{ marginTop: 0.72, marginRight: 3 }} /> {smartlock_type ? smartlock_type + ' - ' : ''} {name}
            </div>
          </div>
        );
      })}
      {areas_groups?.length === 0 && (
        <span style={{ fontStyle: "italic", opacity: 0.7, fontSize: 14 }}>
          Nenhum(a)
        </span>
      )}
    </div>
  );
};

export const getBadgeColumn: React.FC<ITagList> = ({ name, theme, background, color, icon, notFoundText }) => {
  background = background || secondary[theme];
  color = color || "#FFF";

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
      }}
    >
      {name && (
        <div style={{ display: "flex" }}>
          <div
            style={{
              padding: 5,
              whiteSpace: "nowrap",
              display: "flex",
              paddingLeft: 7,
              paddingRight: 7,
              borderRadius: 3,
              background,
              color,
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            {icon ? icon : null}
            {name}
          </div>
        </div>
      )}
      {!name && (
        <span style={{ fontStyle: "italic", opacity: 0.7, fontSize: 14 }}>
          {notFoundText ? notFoundText : 'Não informado'}
        </span>
      )}
    </div>
  );
};

export const getBadgeTypeColumn: React.FC<ITagList> = ({
  type,
  icon,
  theme,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex" }} key={type}>
        <div
          style={{
            padding: 5,
            whiteSpace: "nowrap",
            display: "flex",
            paddingLeft: 7,
            paddingRight: 7,
            borderRadius: 3,
            background: '#2d1b67',
            color: "#FFF",
            fontWeight: 600,
            fontSize: 12,
          }}
        >
          {icon ? icon : null}
          {type}
        </div>
      </div>
    </div>
  );
};

export const getBadgeOutlineColumn: React.FC<ITagList> = ({ name, theme, color, icon }) => {
  color = color || secondary[theme];

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
      }}
    >
      {name && (
        <div style={{ display: "flex" }}>
          <div
            style={{
              padding: 5,
              whiteSpace: "nowrap",
              display: "flex",
              paddingLeft: 7,
              paddingRight: 7,
              borderRadius: 3,
              background: "transparent",
              color,
              border: `1px solid ${color}`,
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            {icon ? icon : null}
            {name}
          </div>
        </div>
      )}
      {!name && (
        <span style={{ fontStyle: "italic", opacity: 0.7, fontSize: 14 }}>
          Não informado
        </span>
      )}
    </div>
  );
};

export const getBroker: React.FC<ITagList> = ({ person, theme }) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
      }}
    >
      {person.broker && (
        <div style={{ display: "flex" }}>
          <div
            style={{
              padding: 5,
              whiteSpace: "nowrap",
              display: "flex",
              paddingLeft: 7,
              paddingRight: 7,
              borderRadius: 3,
              color: secondary[theme],
              border: `1px solid ${secondary[theme]}`,
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            {get_first_name(person.broker)}
          </div>
        </div>
      )}
      {!person.broker && (
        <span style={{ fontStyle: "italic", opacity: 0.7, fontSize: 14 }}>
          Nenhum(a)
        </span>
      )}
    </div>
  );
};

export const getFranchise: React.FC<ITagList> = ({ person, theme }) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 5,
        justifyContent: "center",
      }}
    >
      {person.franchise && (
        <div style={{ display: "flex" }}>
          <div
            style={{
              padding: 5,
              whiteSpace: "nowrap",
              display: "flex",
              paddingLeft: 7,
              paddingRight: 7,
              borderRadius: 3,
              color: secondary[theme],
              border: `1px solid ${secondary[theme]}`,
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            {get_first_name(person.franchise)}
          </div>
        </div>
      )}
      {!person.franchise && (
        <span style={{ fontStyle: "italic", opacity: 0.7, fontSize: 14 }}>
          Nenhum(a)
        </span>
      )}
    </div>
  );
};

export const getAnalyst: React.FC<ITagList> = ({ proposal, theme }) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: 5,
      }}
    >
      {proposal.analyst && (
        <div style={{ display: "flex" }}>
          <div
            style={{
              padding: 5,
              whiteSpace: "nowrap",
              display: "flex",
              paddingLeft: 7,
              paddingRight: 7,
              borderRadius: 3,
              color: secondary[theme],
              border: `1px solid ${secondary[theme]}`,
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            {get_first_name(proposal?.analyst)}
          </div>
        </div>
      )}
      {!proposal.analyst && (
        <span style={{ fontStyle: "italic", opacity: 0.7, fontSize: 14 }}>
          Nenhum(a)
        </span>
      )}
    </div>
  );
};

export const getPerson: React.FC<ITagList> = ({ person, theme }) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: 5,
      }}
    >
      {person.person && (
        <div style={{ display: "flex" }}>
          <div
            style={{
              padding: 5,
              whiteSpace: "nowrap",
              display: "flex",
              paddingLeft: 7,
              paddingRight: 7,
              borderRadius: 3,
              color: "#FFF",
              background: secondary[theme],
              fontSize: 12,
            }}
          >
            {get_first_name(person?.person)}
          </div>
        </div>
      )}
      {!person.person && (
        <span style={{ fontStyle: "italic", opacity: 0.7, fontSize: 14 }}>
          Nenhum(a)
        </span>
      )}
    </div>
  );
};

export const getAuthor: React.FC<ITagList> = ({ person, theme }) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: 5,
      }}
    >
      {person.person && (
        <div style={{ display: "flex" }}>
          <div
            style={{
              padding: 5,
              whiteSpace: "nowrap",
              display: "flex",
              paddingLeft: 7,
              paddingRight: 7,
              borderRadius: 3,
              color: secondary[theme],
              border: `1px solid ${secondary[theme]}`,
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            {get_first_name(person?.person)}
          </div>
        </div>
      )}
      {!person.person && (
        <div style={{ display: "flex" }}>
          <div
            style={{
              padding: 5,
              whiteSpace: "nowrap",
              display: "flex",
              paddingLeft: 7,
              paddingRight: 7,
              borderRadius: 3,
              color: secondary[theme],
              border: `1px solid ${secondary[theme]}`,
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            Empresa
          </div>
        </div>
      )}
    </div>
  );
};

export const getTenants: React.FC<ITagList> = ({ proposal, theme }) => {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
      {proposal.consults?.map((owner: any) => {
        return (
          <div style={{ display: "flex" }}>
            <div
              style={{
                padding: 5,
                whiteSpace: "nowrap",
                display: "flex",
                paddingLeft: 7,
                paddingRight: 7,
                borderRadius: 3,
                background: secondary[theme],
                color: "#FFF",
                fontWeight: 600,
                fontSize: 12,
              }}
            >
              {correctName(owner.customer?.registration_data as any)}
            </div>
          </div>
        );
      })}
      {proposal.consults?.length === 0 && (
        <span style={{ fontStyle: "italic", opacity: 0.7, fontSize: 14 }}>
          Nenhum(a)
        </span>
      )}
    </div>
  );
};

export const getOwners: React.FC<ITagList> = ({ proposal, theme }) => {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
      {proposal.property &&
        proposal.property.owners.map((owner: any) => {
          return (
            <div style={{ display: "flex" }}>
              <div
                style={{
                  padding: 5,
                  whiteSpace: "nowrap",
                  display: "flex",
                  paddingLeft: 7,
                  paddingRight: 7,
                  borderRadius: 3,
                  background: secondary[theme],
                  color: "#FFF",
                  fontWeight: 600,
                  fontSize: 12,
                }}
              >
                {correctName(owner.customer?.registration_data as any)}
              </div>
            </div>
          );
        })}
      {(!proposal.property ||
        (proposal.property && proposal?.property?.owners.length === 0)) && (
          <span style={{ fontStyle: "italic", opacity: 0.7, fontSize: 14 }}>
            Nenhum(a)
          </span>
        )}
    </div>
  );
};

export const getLogo = ({ logo, theme }: { logo: string, theme: string }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: '100px', height: '100px', overflow: "hidden" }}>
      <img src={logo} alt="Logo Empresa" style={{ objectFit: 'contain',  width: '100px', height: '100px'  }} />
    </div>
  )
}

export const getStatus: React.FC<ITagList> = ({ color, text, icon }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textTransform: "uppercase",
      }}
    >
      <div
        style={{
          whiteSpace: "nowrap",
          color: color,
          border: `1px solid ${color}`,
          padding: "5px 10px",
          fontSize: 12,
          borderRadius: 4,
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          justifyItems: 'center'
        }}
      >
        {icon ? icon : null} {text}
      </div>
    </div>
  );
};

export const getCheckStatus: React.FC<ITagList> = ({ color, text, icon, dateSrt }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: 'column',
        gap: 2,
        justifyContent: "center",
        alignItems: "center",
        textTransform: "uppercase",
      }}
    >
      <div
        style={{
          whiteSpace: "nowrap",
          color: color,
          border: `1px solid ${color}`,
          padding: "5px 10px",
          fontSize: 12,
          borderRadius: 4,
          fontWeight: 600,
          display: 'flex',
          alignItems: 'center',
          justifyItems: 'center'
        }}
      >
        {icon ? icon : null} {text}
      </div>

      <div style={{ minHeight: '18px', marginTop: 4 }}>
        {dateSrt && (
          <div style={{ fontSize: 12 }}>
            {dateSrt}
          </div>
        )}

        {!dateSrt && (
          <div style={{ fontStyle: "italic", opacity: 0.7, fontSize: 12 }}>
            Não realizado
          </div>
        )}
      </div>
    </div >
  );
};
